module.exports = __webpack_public_path__ + "static/6b2b7d9e18e5f91655bfda709204304b7b1630922dbcc8796e57373d6a66d0e3-8af145a7c9cbc55dd0c5c0d6d3ee0e1d.jpeg";